/**
 * Wraps the app user interface components
 */

import React, { useCallback, useEffect, useState } from 'react';
import Dialog from '../elements/Dialog/Dialog';
import Toast from '../elements/Toast/Toast';
import LoadTest from '../loaders/LoadTest/LoadTest';
import Router from '../Router/Router';
import { useIsDemoMode } from '../../data/hooks/ui/useIsDemoMode';
import DemoRouter from '../Router/DemoRouter';

const UserInterface = (props) => {
    const [visible, setVisible] = useState(true),
        [loadTest, setLoadTest] = useState(false),
        isDemoMode = useIsDemoMode(),
        forceUpdate = useCallback(() => {
            setVisible(false);
        }, []);

    useEffect(() => {
        if (!visible) setVisible(true);
    }, [visible]);

    useEffect(() => {
        app.forceUpdate = forceUpdate;
        app.loadTest = setLoadTest;
    }, [setLoadTest, forceUpdate]);

    if (!visible) return null;

    return (
        <>
            {loadTest ? <LoadTest /> : isDemoMode ? <DemoRouter /> : <Router />}
            <Toast />
            <Dialog />
        </>
    );
};

export default UserInterface;
